<div class="heading">
  <div>
    <h2>رابطه سرعت و ولتاژ</h2>
    <small>هر نقطه یک نمونه ثبت‌شده در زمان حرکت است</small>
  </div>
  <span
    class="correlation"
    [class.strong]="strongCorrelation"
    [class.unavailable]="correlation == null"
  >
    ضریب همبستگی:
    <bdi *ngIf="correlation != null; else noCorrelation">{{
      correlation | number: "1.2-2" : "en-US"
    }}</bdi>
    <ng-template #noCorrelation>قابل محاسبه نیست</ng-template>
  </span>
</div>
<div *ngIf="hasData" class="controls" aria-label="کنترل زوم رابطه سرعت و ولتاژ">
  <button
    type="button"
    (click)="zoom(1.25)"
    aria-label="بزرگ‌نمایی کمتر"
    title="بزرگ‌نمایی کمتر"
  >
    −
  </button>
  <button type="button" (click)="resetZoom()">بازنشانی زوم</button>
  <button
    type="button"
    (click)="zoom(0.8)"
    aria-label="بزرگ‌نمایی بیشتر"
    title="بزرگ‌نمایی بیشتر"
  >
    +
  </button>
</div>
<div
  *ngIf="hasData; else empty"
  echarts
  [options]="options"
  [autoResize]="true"
  (chartInit)="chart = $event"
  class="scatter-chart"
  dir="ltr"
></div>
<ng-template #empty>
  <div class="empty" role="status">
    نمونهٔ معتبری هنگام حرکت برای نمایش رابطه سرعت و ولتاژ موجود نیست.
  </div>
</ng-template>
<p *ngIf="hasData" class="zoom-hint">
  با چرخ موس زوم کنید و با کشیدن نمودار جابه‌جا شوید؛ نوار پایین، بازه سرعت را
  تنظیم می‌کند.
</p>
<p>
  همبستگی آماری به‌معنای رابطه علت و معلولی نیست. ولتاژ ممکن است با دور موتور،
  بار الکتریکی و رگولاتور تغییر کند.
</p>
